var TimeModeActivityRedirector = xClass("TimeModeActivityRedirector", BaseRedirector)
TimeModeActivityRedirector.prototype.getName = function () {
    return "timeMode"
}

TimeModeActivityRedirector.prototype.hasHighPriorityAction = function () {
    return false
}

TimeModeActivityRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param

    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene || scene.name === 'PreloadScene') {
        return false
    } else {
        let inHome = scene && scene.name === "HomeScene"
        let uid = UserManager.getInstance().uid
        let isMyself = param["inviteCode"] && +param["inviteCode"] === uid || false
        let lastPanel = PopoutManager.getLastPopoutPanel()
        let isTimeModePanelPopup = lastPanel && lastPanel.class.__cname === "TimeModeActivityPanel"
        let isTimeMode = self.param["timeModeShareId"] && self.param["nickname"]
        let logic = require("activity/TimeModeActivity/TimeModeActivityLogic").getInstance()

        if (!isTimeMode) {
            return  true
        }
        if (!logic.isActivityOpen()) {
            Toast.make(getText("error.tip.761630")) //活动未开启
            return true
        }
        if (isMyself) {
            Toast.make(getText("error.tip.761634")) //不能给自己加
            return true
        }
        if (!_G.kIsNewUser) {
            Toast.make(getText("error.tip.761636")) //必须是新用户
            return true
        }
        let shareId = self.param["timeModeShareId"]
        let nickname = HeDisplayUtil.urlDecode(self.param["nickname"])
        let inviteCode = +param["inviteCode"]
        if (isTimeModePanelPopup || !inHome) {
            logic.helpFriendGetTimes(shareId, nickname, inviteCode)
            return true
        }else {
            return new Promise((resolve) => {
                logic.showPanel({
                    shareId, shareId,
                    nickname: nickname,
                    uid: inviteCode
                }, resolve)
            })
        }
    }
}
module.exports = TimeModeActivityRedirector